import React, { FC } from 'react';
import { L, SUPPORTED_LANGUAGES } from 'harmony-language';
import { Select } from './select';
import { LanguageCode } from 'harmony-constants';

interface SelectLanguageProps {
    language: LanguageCode | null;
    onChange: (l: LanguageCode) => void;
}

export const SelectLanguage: FC<SelectLanguageProps> = (props) => {
    const { language, onChange } = props;

    const menuItems = SUPPORTED_LANGUAGES.map(language => ({
        id: language.code,
        value: language.code,
        label: L[language.description]()
    }));

    return (
        <Select
            label={L.selectLanguage()}
            list={menuItems}
            item={menuItems.find(x => x.value === language)}
            onChange={(v) => onChange(v.value)}/>
    );
};
